import { produce } from "immer";
import * as uiActions from "../uiActions";

import deepmerge from "deepmerge";
import combineMerge from "config/combineMerge";

const initialState = {
  byId: {},
  allIds: [],
  hasMore: false
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case uiActions.FETCH_CONTACTS_SUCCESS: {
      const allIds = action.payload.contacts.map(message => message.id);
      const byId = action.payload.contacts.reduce((obj, message) => {
        obj[message.id] = {
          ...message
        };

        return obj;
      }, {});

      draft.byId = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });

      draft.hasMore = action.payload.hasMore;
      if (action.payload.isStart) {
        draft.allIds = allIds;
      } else {
        draft.allIds = deepmerge(draft.allIds, allIds, {
          arrayMerge: combineMerge
        });
      }

      break;
    }

    case uiActions.ADD_CONTACT: {
      const { payload } = action;
      draft.byId[payload.id] = payload;
      if (draft.allIds.indexOf(payload.id) < 0) {
        draft.allIds.push(payload.id);
      }
      break;
    }
    case uiActions.UPDATE_CONTACT: {
      const { payload } = action;
      draft.byId[payload.id] = payload;
      break;
    }

    case uiActions.DELETE_CONTACT_SUCCESS:
      const { payload } = action;
      draft.allIds = draft.allIds.filter(item => !payload.includes(item));
      break;

    case uiActions.GET_CONTACT: {
      const { payload } = action;
      draft.byId[payload.id] = payload;
      break;
    }

    default:
      return draft;
  }
}, initialState);

export default reducer;
